'use strict';

/**
 * MapUtil is primarily responsible for formatting data so that it can be passed
 * to angular-leaflet
 */

var CtrlUtil = require('./utils/CtrlUtil');
var TileUtil = require('./utils/TileUtil');
var DataCaptureUtil = require('./utils/DataCaptureUtil');
var OverlayUtil = require('./utils/OverlayUtil');

function MapUtil ($injector, MapConfig) {

  var tileUtil = $injector.instantiate(TileUtil);
  var dcUtil = $injector.instantiate(DataCaptureUtil, { tileUtil: tileUtil });
  var overlayUtil = $injector.instantiate(OverlayUtil, { tileUtil: tileUtil });

  return {

    // Aliases
    setDefaults: MapConfig.setDefaults.bind(MapConfig),
    getDefaults: MapConfig.getDefaults.bind(MapConfig),
    getDefaultLocation: MapConfig.getDefaultLocation.bind(MapConfig),
    getEvents: MapConfig.getEvents.bind(MapConfig),


    initLayers: function (options) {
      return {
        overlays: {},
        baselayers: tileUtil.getBaseLayer(options)
      };
    },

    // Annotation: AnnotationUtil,
    DataCapture: dcUtil,
    Ctrl: CtrlUtil,
    Tile: tileUtil,
    Overlay: overlayUtil
  };
}

MapUtil.$inject = ['$injector', 'sbMapConfig'];
module.exports = MapUtil;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapUtils.js